export const sidebar_extension = {
  light: {
    sidenavpanelborder: {
      color: "#E2E8F033",
    },
    listpanelbtmborder: {
      color: "#E2E8F033",
    },
    sidenavhover: {
      color: "#001D66",
    },
    arrowcol: {
      color: "#fff",
    },
    arrowcoldark: {
      color: "#000",
    },
    sidenavleftactivecol: {
      color: "#001D66",
    },
  },
  dark: {
    sidenavpanelborder: {
      color: "#E2E8F033",
    },
    sidenavhover: {
      color: "#001D66",
    },
    arrowcol: {
      color: "#fff",
    },
    arrowcoldark: {
      color: "#000",
    },
    sidenavleftactivecol: {
      color: "#001D66",
    },
    listpanelbtmborder: {
      color: "#E2E8F033",
    },
  },
};
